// Because of JS import hoisting, we need this init code to be here,
// so that following imports in application.js have access to `toastr`

import toastr from 'toastr';

toastr.options.positionClass = 'toast-top-center';
toastr.options.showMethod = 'show';
toastr.options.showDuration = 0;
toastr.options.hideMethod = 'fadeOut';
toastr.options.hideDuration = 200;

const ALLOWED_TYPES = ['success', 'error', 'warning', 'info'];

export function showToast(type, message) {
  if (!ALLOWED_TYPES.includes(type)) return;

  toastr[type](message, '', {
    closeButton: false,
    tapToDismiss: true,
    escapeHtml: true,
  });
}

export function clearToasts() {
  toastr.clear();
  document.getElementById('toast-container')?.remove();
}

window.toastr = toastr;
